import { defineTable } from "convex/server";
import { v } from "convex/values";
import { internalControl } from "../../lib/shared/validators";
import { customFieldValues } from "../custom_fields";

// Estados de una orden de compra: draft, sent, confirmed, partial, received, cancelled.
export const purchaseOrderStatus = v.union(
  v.literal("draft"),
  v.literal("sent"),
  v.literal("confirmed"),
  v.literal("partial"),
  v.literal("received"),
  v.literal("cancelled"),
);

export const validatorPurchaseOrder = v.object({
  // `code`: nomenclatura interna (OC-0001). Opcional para soportar el borrador del formulario.
  code: v.optional(v.string()),
  // supplierId es opcional en borrador; obligatorio al enviar/confirmar.
  supplierId: v.optional(v.id("suppliers")),
  status: purchaseOrderStatus,

  orderDate: v.number(),
  expectedDeliveryDate: v.optional(v.number()),
  receivedDate: v.optional(v.number()),

  subtotal: v.number(),
  taxAmount: v.number(),
  discountAmount: v.optional(v.number()),
  totalAmount: v.number(),
  currency: v.string(),

  notes: v.optional(v.string()),
  paymentTerms: v.optional(v.string()),
  shippingAddress: v.optional(v.string()),

  cancelReason: v.optional(v.string()),
  cancelDate: v.optional(v.number()),

  internalControl,
  /** Valores de campos personalizados (Colecciones), por key de definición. */
  customFields: v.optional(customFieldValues),
});

export const purchase_orders = defineTable(validatorPurchaseOrder)
  .index("by_company_id", ["internalControl.companyId"])
  .index("by_company_and_branch", [
    "internalControl.companyId",
    "internalControl.branchId",
  ])
  .index("by_branch_id", ["internalControl.branchId"])
  .index("by_supplier", ["supplierId"])
  .index("by_status", ["status"])
  .index("by_company_and_status", ["internalControl.companyId", "status"])
  .index("by_company_and_code", ["internalControl.companyId", "code"])
  .index("by_state", ["internalControl.state"])
  .index("by_created_at", ["internalControl.createdAt"]);
